export const IIT_AGENT_DOWNLOAD_LINK = 'https://iit.com.ua/downloads';

export const JAVA_DOWNLOAD_LINK = 'https://www.java.com/download/';

export const FILE_KEY_TYPES = ['.jks', '.dat', '.pfx'];
